import { combineReducers } from "@reduxjs/toolkit";
import userReducer from "../Pages/User/Redux/userSlice";
import alertReducer from "../Redux/Alert/alertSlice";
import authReducer from "../Redux/Auth/authSlice";
import layoutReducer from "../Redux/Layout/layoutSlice";
import paginationReducer from "../Redux/Pagination/paginationSlice";
const rootReducer = combineReducers({
  auth: authReducer,
  alert: alertReducer,
  layout: layoutReducer,
  user: userReducer,
  pagination: paginationReducer,
});

export default rootReducer;
